module.exports = __webpack_public_path__ + "static/img/xygl.f6574c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xygl.png
// module id = y1jj
// module chunks = 1